import { createAsyncThunk } from '@reduxjs/toolkit';

import { completeUploadFileMutation, uploadFileMutation } from '~/shared/graphql-queries';
import initUploadFileMutation from '~/shared/graphql-queries/files/init-upload-file-mutation';
import removeByPathFileMutation from '~/shared/graphql-queries/files/remove-by-path-file-mutation';
import { initializeApollo } from '~/shared/libs/apollo/apollo-provider';

export const completeUploadFile = createAsyncThunk('files/completeUploadFile', async (args) => {
  const apolloClient = await initializeApollo();

  return apolloClient.mutate({
    mutation: completeUploadFileMutation,
    variables: {
      fileName: args?.fileName,
      uploadId: args?.uploadId,
      parts: args?.parts,
    },
  });
});

export const initUploadFile = createAsyncThunk('files/initUploadFile', async (args) => {
  const apolloClient = await initializeApollo();

  return apolloClient.mutate({
    mutation: initUploadFileMutation,
    variables: {
      fileName: args?.fileName,
      language: args?.language,
      destination: args?.destination,
      fileFormat: args?.fileFormat,
    },
  });
});

export const uploadFile = createAsyncThunk('files/uploadFile', async (args) => {
  const apolloClient = await initializeApollo();

  return apolloClient.mutate({
    mutation: uploadFileMutation,
    variables: {
      files: args?.files,
      filesMetaInfo: args?.filesMetaInfo,
    },
  });
});

export const removeByPathFile = createAsyncThunk('files/removeByPathFile', async (args) => {
  const apolloClient = await initializeApollo();

  return apolloClient.mutate({
    mutation: removeByPathFileMutation,
    variables: {
      files: args?.files,
    },
  });
});
